<template>
  <div>
    <nav aria-label="Page navigation example">
      <ul class="flex flex-wrap justify-center gap-4 my-4">
        <li class="page-item">
          <button
            class="px-4 py-2 rounded-full shadow bg-default-100"
            v-on:click="paginate(pages.links.first)"
            aria-label="Previous"
          >
            Primeiro
          </button>
        </li>
        <li class="page-item" v-bind:class="{ disabled: !pages.links.prev }">
          <button
            class="w-10 h-10 flex items-center justify-center rounded-full shadow bg-default-100"
            v-on:click="paginate(pages.links.prev)"
            aria-label="Previous"
          >
            <svg class="w-4 h-4 fill-current" viewBox="0 0 20 20"><path d="M12.707 5.293a1 1 0 010 1.414L9.414 10l3.293 3.293a1 1 0 01-1.414 1.414l-4-4a1 1 0 010-1.414l4-4a1 1 0 011.414 0z" clip-rule="evenodd" fill-rule="evenodd"></path></svg>
          </button>
        </li>
        <li
          class="page-item"
          v-for="(item, index) in pages.pages"
          :key="index"
          v-bind:aria-current="{ page: item.number === meta.current_page }"
        >
          <button
            class="px-4 py-2 rounded-full shadow bg-default-100"
            v-on:click="paginate(item.link)"
            v-bind:class="{
              'bg-default-500 text-white font-semibold':
                item.number === meta.current_page,
            }"
          >
            {{ item.number }}
          </button>
        </li>
        <li
          class="page-item btn-default"
          v-bind:class="{ disabled: !pages.links.next }"
        >
          <button
            class="w-10 h-10 flex items-center justify-center rounded-full shadow bg-default-100"
            v-on:click="paginate(pages.links.next)"
            aria-label="Next"
          >
            <svg class="w-4 h-4 fill-current" viewBox="0 0 20 20"><path d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z" clip-rule="evenodd" fill-rule="evenodd"></path></svg>
          </button>
        </li>
        <li class="page-item btn-default">
          <button
            class="px-4 py-2 rounded-full shadow bg-default-100"
            v-on:click="paginate(pages.links.last)"
            aria-label="Next"
          >
            Último
          </button>
        </li>
      </ul>
    </nav>
  </div>
</template>

<script>
export default {
  name: "Paginate",
  props: ["meta", "links", "event"],
  data() {
    return {
      pages: {
        pages: null,
        links: null,
      },
    };
  },
  watch: {
    meta: function (val) {
      this.itemsPaginate(this.meta, this.links);
    },
  },
  created: function () {
    this.itemsPaginate(this.meta, this.links);
  },
  methods: {
    paginate(link) {
      this.$emit(this.event, link);
    },
    itemsPaginate(meta, links) {
      let pagination = [];
      let fistPage = parseInt(meta.current_page / 5) * 5;
      let lastPage =
        fistPage + 5 < meta.last_page ? fistPage + 5 : meta.last_page;
      for (let i = fistPage; i <= lastPage; i++) {
        if (i > 0) {
          pagination.push({
            number: i,
            link:
              meta.path.indexOf("?") > -1
                ? meta.path + "&page=" + i
                : meta.path + "?page=" + i,
          });
        }
      }
      this.pages = {
        pages: pagination,
        links: links,
      };
    },
  },
};
</script>

<style scoped></style>
